<script>
    import Toggle from '../components/Toggle.svelte';
    import { getUrlParam } from '../utils';

    let showLocations = false;

    let param = getUrlParam('id');
    const src = `https://embed.campuspano.io/index.html?l=${param}`;
    const hsrc = `https://embed.campuspano.io/index.html?l=${param}&h=true`;
    $: iframe = `<iframe class="cmpspno" src="${(showLocations) ? hsrc : src}" frameborder="0"></iframe>`;
    let c0 = `<style>`;
    let c1 = `.cmpspno {`;
    let c2 = `width: 100%;`;
    let c3 = `height: 500px;`;
    let c4 = `}`;
    let c5 = `</style>`;

    function toggleShowLocations() {
        showLocations = !showLocations;
    }
</script>

<h1>Embed</h1>
<div class="card">
    <iframe title="Virtual Tour" class="cmpspno" src={(showLocations) ? hsrc : src} frameborder="0"></iframe>
    <div class="row">
        <h4>Show locations</h4>
        <Toggle toggled={showLocations} clickFunc={toggleShowLocations} />
    </div>
    <h3>Copy Embed Code</h3>
    <div class="dark-card">
        <p class="code">{iframe}</p>
    </div>
    <h3>Copy Styles</h3>
    <div class="dark-card">
        <p class="code">{c0}</p>
        <p class="code i1">{c1}</p>
        <p class="code i2">{c2}</p>
        <p class="code i2">{c3}</p>
        <p class="code i1">{c4}</p>
        <p class="code">{c5}</p>
    </div>
</div>

<style>
    h1 {
        margin-bottom: 15px;
    }

    h4 {
        margin: 15px;
    }

    h3 {
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .row {
        display: flex;
        flex-direction: row;
        align-items: center;
        justfy-content: center;
    }

    .cmpspno {
        width: 100%;
        height: 500px;
        border-radius: 5px;
        box-shadow: var(--box-shadow);
        margin-bottom: 10px;
    }

    .card {
        text-align: left;
        color: var(--off-black);
        background-color: var(--white);
        padding: 20px;
        border-radius: 15px;
        box-shadow: var(--box-shadow);
    }

    .dark-card {
        color: var(--white);
        background-color: var(--off-black);
        padding: 20px;
        border-radius: 15px;
        box-shadow: var(--box-shadow);
    }
</style>
